<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Icon } from '@Shelly/shelly-design-system';

	/** Accessible label for the close button */
	export let ariaLabel: string = 'Close';

	const dispatch = createEventDispatcher<{ click: void }>();
</script>

<button
	type="button"
	class="promo-modal-close-btn"
	aria-label={ariaLabel}
	on:click={() => dispatch('click')}
>
	<Icon icon="fal fa-xmark" size="m" />
</button>

<style>
	.promo-modal-close-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		padding: 0;
		margin: 0;
		background: transparent;
		border: none;
		cursor: pointer;
		color: var(--color-white, #ffffff);
		transition: opacity 0.15s ease;
	}

	.promo-modal-close-btn:hover {
		opacity: 0.7;
	}

	.promo-modal-close-btn:focus-visible {
		outline: 2px solid var(--color-primary, #2491ff);
		outline-offset: 2px;
		border-radius: 4px;
	}
</style>
